import React from 'react';

export default class NoResults extends React.Component {
  render() {
    return (
      <div className="container">
        <div className="row">
          <div className="col-xs-16">
            {this.props.filter.longitude && this.props.filter.latitude ?
              (<span>There are no listings within 20 miles of your location.</span>) :
              (<span>No results found with above filters.</span>)}<br/>
            <span>You can either modify your search options or visit one of our Locations to view our listings.</span>
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/search/no-results.jsx